import React from 'react';
import { has, pathEq, complement, sortWith, descend, compose, path } from 'ramda';

import HistoryEntry from 'components/HistoryEntry';
import HistoryEntryHeader from 'components/HistoryEntryHeader';
import HistoryEntryColumns from 'components/HistoryEntryColumns';
import HistoryEntryColumn from 'components/HistoryEntryColumn';
import CommonHistoryEntryControls from 'routes/Documents/components/CommonHistoryEntryControls';

import { formatDate, dateValue } from 'lib/dateDisplay';
import { getLatestFinishedCommitData } from 'lib/documentHandling';

const msg = id => ({ id });
const opt = o => `rehabilitation.opts.${o}`;

const isActive = complement(pathEq(['content', 'hasEnded'], 'yes'));

export const sorter = sortWith([descend(isActive), descend(compose(dateValue, path(['content', 'start'])))]);

const optMsg = m => msg(opt(m));

const formatHeader = (fields, fm) =>
  has('category', fields) && fields.category !== 'other'
    ? `${fm(optMsg(fields.category))}${has(fields.category, fields) ? `: ${fm(optMsg(fields[fields.category]))}` : ''}`
    : has('category', fields) && fields.category === 'other'
      ? `${fm(optMsg(fields.category))}${has(fields.category, fields) ? `: ${fields[fields.category]}` : ''}`
      : null;

const historyMapper =
  (name, edit) =>
  (d, { formatMessage }) => (
    <HistoryEntry key={d.documentId}>
      <HistoryEntryHeader title={formatHeader(d.content, formatMessage)} active={isActive(d)}>
        <CommonHistoryEntryControls action={() => edit(name, d.documentId, getLatestFinishedCommitData(d))} />
      </HistoryEntryHeader>
      <HistoryEntryColumns>
        <HistoryEntryColumn header={formatMessage(msg('rehabilitation.labels.start'))}>
          <p>{formatDate(d.content.start)}</p>
        </HistoryEntryColumn>
        {d.content.hasEnded === 'yes' && (
          <HistoryEntryColumn header={formatMessage(msg('rehabilitation.labels.end'))}>
            <p>{formatDate(d.content.end)}</p>
          </HistoryEntryColumn>
        )}
        {d.content.additionalInfo && (
          <HistoryEntryColumn header={formatMessage(msg('rehabilitation.labels.additionalInfo'))} smallScaling={12}>
            <p>{d.content.additionalInfo}</p>
          </HistoryEntryColumn>
        )}
      </HistoryEntryColumns>
    </HistoryEntry>
  );

export default historyMapper;
